<template>
	<el-dialog
		title="物流管理"
		:visible.sync="visible"
		width="720px"
		center
		append-to-body
		@close="handleClose"
	>
		<el-tabs v-model="activeTab">
			<el-tab-pane label="修改" name="modify">
				<div v-loading="packLoading">
					<template v-if="form.changes.length">
						<div v-for="(row, index) in form.changes" :key="row.pack_id || index" class="pack_row">
							<div class="pack_row_head">包裹 {{ index + 1 }}</div>
							<div class="current_info">
								<p><span class="label">当前快递：</span>{{ row.old_delivery_name || row.old_delivery_id || '—' }}</p>
								<p><span class="label">当前运单：</span>{{ row.old_waybill_id || '—' }}</p>
							</div>
							<el-form ref="changeForm" :model="form" label-width="90px" size="small">
								<el-form-item
									label="新快递"
									:prop="'changes.' + index + '.new_delivery_id'"
									:rules="[{ required: true, message: '请选择快递公司', trigger: 'change' }]"
								>
									<el-select
										v-model="row.new_delivery_id"
										placeholder="请选择快递公司"
										filterable
										style="width: 100%;"
										:loading="companyLoading"
									>
										<el-option
											v-for="item in companies"
											:key="item.delivery_id"
											:label="item.delivery_name"
											:value="item.delivery_id"
										/>
									</el-select>
								</el-form-item>
								<el-form-item
									label="新运单号"
									:prop="'changes.' + index + '.new_waybill_id'"
									:rules="[{ required: true, message: '请输入运单号', trigger: 'blur' }]"
								>
									<el-input v-model="row.new_waybill_id" placeholder="请输入新运单号" clearable />
								</el-form-item>
							</el-form>
						</div>
					</template>
					<p v-else class="empty_tip">暂无已发货包裹，请先同步订单</p>
				</div>
			</el-tab-pane>
			<el-tab-pane label="补发" name="compensate" :disabled="!canCompensate">
				<div v-loading="packLoading">
					<p v-if="!canCompensate" class="empty_tip">暂无已发货包裹，无法补发</p>
					<template v-else>
						<p v-if="compensationCount >= maxPacks" class="empty_tip">补发次数已达上限（{{ maxPacks }} 次）</p>
						<el-form v-else ref="compensateForm" :model="compensateForm" label-width="90px" size="small">
							<div v-for="(row, index) in compensateForm.packs" :key="'comp-' + index" class="pack_row">
								<div class="pack_row_head">
									<span>包裹 {{ packCount + index + 1 }}</span>
									<el-button
										v-if="compensateForm.packs.length > 1"
										type="text"
										class="pack_remove"
										@click="removeCompensateRow(index)"
									>删除</el-button>
								</div>
								<el-form-item
									label="快递公司"
									:prop="'packs.' + index + '.delivery_id'"
									:rules="[{ required: true, message: '请选择快递公司', trigger: 'change' }]"
								>
									<el-select
										v-model="row.delivery_id"
										placeholder="请选择快递公司"
										filterable
										style="width: 100%;"
										:loading="companyLoading"
									>
										<el-option
											v-for="item in companies"
											:key="item.delivery_id"
											:label="item.delivery_name"
											:value="item.delivery_id"
										/>
									</el-select>
								</el-form-item>
								<el-form-item
									label="运单号"
									:prop="'packs.' + index + '.waybill_id'"
									:rules="[{ required: true, message: '请输入运单号', trigger: 'blur' }]"
								>
									<el-input v-model="row.waybill_id" placeholder="请输入运单号" clearable />
								</el-form-item>
							</div>
							<div class="pack_actions">
								<el-button
									type="text"
									icon="el-icon-plus"
									:disabled="compensateForm.packs.length >= compensateMaxPacks"
									@click="addCompensateRow"
								>添加运单</el-button>
								<span v-if="compensateForm.packs.length >= compensateMaxPacks" class="muted">
									单次最多 {{ compensateMaxPacks }} 条
								</span>
							</div>
						</el-form>
					</template>
				</div>
			</el-tab-pane>
		</el-tabs>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button
				type="primary"
				:loading="submitting"
				:disabled="confirmDisabled"
				@click="handleConfirm"
			>确 认</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'updateDeliveryDialog',
	data() {
		return {
			visible: false,
			targetItem: null,
			activeTab: 'modify',
			companies: [],
			companyLoading: false,
			packLoading: false,
			submitting: false,
			onSuccess: null,
			maxPacks: 10,
			packCount: 0,
			compensationCount: 0,
			form: {
				changes: [],
			},
			compensateForm: {
				packs: [{ delivery_id: '', waybill_id: '' }],
			},
		}
	},
	computed: {
		canCompensate() {
			return this.packCount > 0
		},
		compensateMaxPacks() {
			const remain = this.maxPacks - this.compensationCount
			return Math.max(0, Math.min(this.maxPacks, remain))
		},
		confirmDisabled() {
			if (this.activeTab === 'modify') {
				return !this.form.changes.length
			}
			return !this.canCompensate || this.compensationCount >= this.maxPacks
		},
	},
	methods: {
		open(item, onSuccess = null) {
			this.targetItem = item
			this.onSuccess = onSuccess
			this.activeTab = 'modify'
			this.packCount = 0
			this.compensationCount = 0
			this.form = { changes: [] }
			this.compensateForm = { packs: [{ delivery_id: '', waybill_id: '' }] }
			this.visible = true
			this.loadCompanies()
			this.loadPacks()
		},
		loadCompanies() {
			if (this.companies.length > 0) {
				return
			}
			this.companyLoading = true
			this.$store.dispatch('wxshopDelivery/getDeliveryCompaniesAction', {
				success: (res) => {
					this.companyLoading = false
					if (res.code === 200) {
						this.companies = Array.isArray(res.data?.companies) ? res.data.companies : []
					}
				},
				error: () => {
					this.companyLoading = false
				},
			})
		},
		loadPacks() {
			if (!this.targetItem) {
				return
			}
			this.packLoading = true
			this.$store.dispatch('wxshopDelivery/getDeliveryPacksAction', {
				data: {
					wx_order_id: this.targetItem.wx_order_id,
					shop_id: this.targetItem.shop_id,
				},
				success: (res) => {
					this.packLoading = false
					if (res.code !== 200) {
						this.$message.error(res.msg || '加载包裹失败')
						return
					}
					const packs = Array.isArray(res.data?.packs) ? res.data.packs : []
					this.packCount = Number(res.data?.pack_count) || packs.length
					this.compensationCount = Number(res.data?.compensation_count) || 0
					this.form.changes = packs.map((pack) => ({
						pack_id: pack.id,
						old_delivery_id: pack.delivery_id || '',
						old_delivery_name: pack.delivery_name || '',
						old_waybill_id: pack.waybill_id || '',
						new_delivery_id: pack.delivery_id || '',
						new_waybill_id: pack.waybill_id || '',
					}))
				},
				error: () => {
					this.packLoading = false
					this.$message.error('加载包裹失败')
				},
			})
		},
		addCompensateRow() {
			if (this.compensateForm.packs.length >= this.compensateMaxPacks) {
				return
			}
			this.compensateForm.packs.push({ delivery_id: '', waybill_id: '' })
		},
		removeCompensateRow(index) {
			this.compensateForm.packs.splice(index, 1)
		},
		handleConfirm() {
			if (!this.targetItem) {
				return
			}
			if (this.activeTab === 'modify') {
				this.submitModify()
			} else {
				this.submitCompensate()
			}
		},
		submitModify() {
			if (!this.form.changes.length) {
				return
			}
			const changes = []
			for (const row of this.form.changes) {
				const oldDeliveryId = String(row.old_delivery_id || '').trim()
				const oldWaybillId = String(row.old_waybill_id || '').trim()
				const newDeliveryId = String(row.new_delivery_id || '').trim()
				const newWaybillId = String(row.new_waybill_id || '').trim()
				if (oldDeliveryId === newDeliveryId && oldWaybillId === newWaybillId) {
					continue
				}
				if (!newDeliveryId || !newWaybillId) {
					this.$message.error('请完整填写新快递公司与运单号')
					return
				}
				changes.push({
					old_delivery_id: oldDeliveryId,
					old_waybill_id: oldWaybillId,
					new_delivery_id: newDeliveryId,
					new_waybill_id: newWaybillId,
				})
			}
			if (!changes.length) {
				this.$message.warning('没有修改任何物流信息')
				return
			}
			this.submitting = true
			this.$store.dispatch('wxshopDelivery/postUpdateDeliveryAction', {
				data: {
					wx_order_id: this.targetItem.wx_order_id,
					shop_id: this.targetItem.shop_id,
					changes,
				},
				success: (res) => {
					this.submitting = false
					if (res.code === 200) {
						this.$message.success(res.msg || res.message || '修改成功')
						this.visible = false
						if (typeof this.onSuccess === 'function') {
							this.onSuccess(res)
						}
					} else {
						this.$message.error(res.msg || res.message || '修改失败')
					}
				},
				error: (err) => {
					this.submitting = false
					this.$message.error(err?.msg || err?.message || '修改失败')
				},
			})
		},
		submitCompensate() {
			if (!this.canCompensate || this.compensationCount >= this.maxPacks) {
				return
			}
			const packs = []
			for (const row of this.compensateForm.packs) {
				const deliveryId = String(row.delivery_id || '').trim()
				const waybillId = String(row.waybill_id || '').trim()
				if (!deliveryId || !waybillId) {
					this.$message.error('请完整填写快递公司与运单号')
					return
				}
				packs.push({ delivery_id: deliveryId, waybill_id: waybillId })
			}
			if (!packs.length) {
				this.$message.warning('请填写补发运单')
				return
			}
			this.submitting = true
			this.$store.dispatch('wxshopDelivery/postCompensateDeliverAction', {
				data: {
					wx_order_id: this.targetItem.wx_order_id,
					shop_id: this.targetItem.shop_id,
					packs,
				},
				success: (res) => {
					this.submitting = false
					if (res.code === 200) {
						const partial = res.data?.partial
						this.$message.success(res.msg || res.message || (partial ? '部分补发成功' : '补发成功'))
						this.visible = false
						if (typeof this.onSuccess === 'function') {
							this.onSuccess(res)
						}
					} else {
						this.$message.error(res.msg || res.message || '补发失败')
					}
				},
				error: (err) => {
					this.submitting = false
					this.$message.error(err?.msg || err?.message || '补发失败')
				},
			})
		},
		handleClose() {
			this.visible = false
			this.submitting = false
		},
	},
}
</script>

<style scoped>
.pack_row {
	border: 1px solid #ebeef5;
	border-radius: 4px;
	padding: 12px;
	margin-bottom: 12px;
}
.pack_row_head {
	font-weight: 500;
	margin-bottom: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.pack_remove {
	padding: 0;
}
.current_info {
	background: #f5f7fa;
	border-radius: 4px;
	padding: 8px 12px;
	margin-bottom: 12px;
	font-size: 13px;
}
.current_info p {
	margin: 4px 0;
}
.label {
	color: #909399;
}
.empty_tip {
	text-align: center;
	color: #909399;
	padding: 24px 0;
}
.pack_actions {
	margin-top: 4px;
}
.muted {
	color: #909399;
	font-size: 12px;
	margin-left: 8px;
}
</style>
